//added enter-view  https://pudding.cool/process/scrollytelling-sticky/
import enterView from 'enter-view';
enterView({
  selector: '.content',
  enter: function(el) {
    el.classList.add('entered');
  },
  exit: function(el) {
    el.classList.remove('entered');
  },
  progress: function(el, progress) {
    el.style.opacity = progress;
  },
  offset: 0.4, // enter at middle of viewport
  once: false, // trigger just once
});

//end enter-view

//video scroll
var frameNumber = 0, // start video at frame 0
    // lower numbers = faster playback
    playbackConst = 450, 
    // get page height from video duration
    setHeight = document.getElementById("set-height"), 
    // select video element         
    vid = document.getElementById('v0'); 

// dynamically set the page height according to video length
vid.addEventListener('loadedmetadata', function() {
  setHeight.style.height = (Math.floor(vid.duration)-1000) * playbackConst + "px";
});

